import { observer } from "mobx-react";
import { Empty } from "antd";
import { OFTableController } from "../OFTableController";

const NoContent = observer(
  ({ emptyProps, ofTableController }: { emptyProps?: any; ofTableController: OFTableController }) => {
    const { tableWidth, tableHeight, headerHeight, props } = ofTableController;

    return (
      <div
        className="noData"
        style={{
          position: "sticky",
          left: 0,
          top: headerHeight,
          width: tableWidth,
          height: Math.max(tableHeight - headerHeight, 0),
          display: "grid",
          placeItems: "center",
        }}
      >
        <Empty
          image={(props?.emptyProps && props?.emptyProps?.image) || Empty.PRESENTED_IMAGE_SIMPLE}
          imageStyle={{ height: 80 }}
          description={props?.emptyProps && props?.emptyProps?.description}
          style={{ margin: 0 }}
        >
          {props?.emptyProps && props?.emptyProps?.button}
        </Empty>
      </div>
    );
  }
);

export default NoContent;
